// New version src/Common/pipes/capitalize_formatter.pipe.ts
// Old version src/CaseDotStar.ServicePackages.Frontend.Common/scripts/common/filters/common_capitalize_filter.ts

import {
	Pipe,
	PipeTransform,
} from '@angular/core';

@Pipe({
	name: 'commonCapitalizeFormatter',
})
export class CommonCapitalizeFormatter implements PipeTransform {
	transform (data: string): string {
		return (!!data && 0 < data.length) ? data.charAt(0).toUpperCase() + data.substr(1) : '';
	}
}
